export const getIconStroke = size => {
  let strokeWidth = ''
  let stroke = 'currentColor'
  switch (size) {
    case 'fine':
      strokeWidth = '0.1'
      break
    case 'xs':
      strokeWidth = '0.75'
      break
    case 'md':
      strokeWidth = '0.5'
      break
    case 'lg':
      strokeWidth = '0.25'
      break
    case 'xl':
      strokeWidth = '0'
      break
    default:
      strokeWidth = ''
      stroke = ''
  }
  return { strokeWidth, stroke }
}
